import FAQSection from '../modules/faq-section';

const sections = document.querySelectorAll('[data-faq]');
const initFaq = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new FAQSection(el);
    });
};

initFaq(sections);
